import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`Posthog.capture("user signed up", %{
  distinct_id: distinct_id_of_the_user
})
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`Posthog.capture("User signed up", %{
  distinct_id: distinct_id_of_the_user,
  properties: %{
    login_type: "email",
    is_free_trial: true
  }
})
`}</code></pre>
    <h3 {...{
      "id": "batching-events"
    }}>{`Batching events`}</h3>
    <p>{`To capture multiple events at once, use `}<inlineCode parentName="p">{`batch()`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`Posthog.batch([{"user signed up", [distinct_id: distinct_id_of_the_user], nil}])
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      